module.exports = __webpack_public_path__ + "img/detail_page-top.2588e527.png";